import React from 'react';
import '../../styles/collaborators/collaborators.css';
import beckmanLogo from '../../assets/img/Beckman_Coulter_Logo.svg.png';

const AzTeam = () => {

	return (
		<section className="beckamSection">
            <span className="text-content">
				<h2>Beckman Coulter Team</h2>
				<p>
					Beckman Coulter Team has a team of applications specialists across Europe, including two in Sweden, who can develop automated methods 
					that can match manual processing. In ProMS, our team is lead by experience field application specialist, Kseniya Korchagina. Our team 
					can also assist with the data tracking aspects of the liquid handling software and provide support in integrating our software with 
					laboratory management software
				</p>
			</span>
			<span className="logo-encasing">
				<img
					src={beckmanLogo}
					alt="Beckman Logo"
					className="beckmanLogo"
				/>
			</span>
			<span className="text-content">
				<p>
					Your hospital, academic initiative or company... ProMS is just a begining of a journey where we together bring proteomics to 
					contribute for clinical decision support. We aim to develop a sustainable innovation environment bringing in new methods and 
					technologies and their clinical applications to use. Please <a href="/contact">join us</a> to develop future precision medicine!
				</p>
			</span>
		</section>
	);
};

export default AzTeam;
